// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import sa from 'sa-sdk-javascript'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// 引入字体
import './assets/fonts/font'
import './assets/fonts/font.css'

// 引入rem布局
import './assets/js/plugins/rem'

// 使用户微信修改字体大小对应用失效
import './assets/js/plugins/disableFontSize'

// 添加API模块
import API from './module/API'

// 移动端弹窗组件
import weui from 'weui.js'
import dialog from './assets/js/plugins/sz-dialog/sz-dialog'

// 添加埋点工具
import {
  statisticsPing,
  toast,
  isMobile,
  setWXSDK
} from './module/tools'

// 添加配置信息
import GLOBAL from './config/global'

// 添加异常监控
import badjs from 'badjs-report'

// 添加简易状态管理
import store from './store'
Vue.prototype.$http = axios

Vue.filter('img', (val) => {
  return process.env.STATIC_URL + val
})
Vue.filter('asgard', (val) => {
  return process.env.ASGARD_URL + val
})
Vue.prototype.$api = new API()
Vue.use(dialog)
Vue.prototype.$weui = weui
Vue.prototype.$statisticsPing = statisticsPing
Vue.prototype.$toast = toast
Vue.prototype.$global = GLOBAL
Vue.prototype.$wxReady = setWXSDK

// 初始化
var apiUrl = process.env.NODE_ENV === 'testing' ? location.origin : process.env.API_URL
badjs.init({
  id: 2,
  uin: 0,
  random: 1,
  url: apiUrl + '/es/badjs'
})
badjs.tryJs().spyAll()
Vue.prototype.$report = badjs
Vue.prototype.$store = store

// 添加前端异常监控
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENV,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true
    })]
  })
}

// 监听路由变化
router.beforeEach((to, from, next) => {
  to.query._t = String(new Date().getTime())
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // if (to.path !== location.pathname) {
  //   location.assign(to.fullPath)
  // }

  next()
})

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g
//   const isChunkLoadFailed = error.message.match(pattern)
//   const targetPath = router.history.pending.fullPath
//   if (isChunkLoadFailed) {
//     router.replace(targetPath)
//   }
// })

// 初始化神策埋点
function initSensors() {
  try {
    sa.init({
      server_url: process.env.VUE_APP_SENSORS_URL,
      show_log: process.env.VUE_APP_SENSORS_DEBUG === '1',
      web_url: process.env.VUE_APP_SENSORS_URL,
      heatmap: {
        scroll_delay_time: 1000,
        isTrackLink: true
      },
      scrollmap: {
        collect_url() {}
      }
    })
    sa.registerPage({
      platform_type: 'wechat',
      biz_type: 'FA公众号'
    })
    sa.__logout = function () {
      sa.logout(true)
    }
    Vue.prototype.$sa = sa
    window.$sa = sa // 这里是为了方便在API模块中调用
  } catch (e) {
    console.log(e)
  }
}

initSensors()
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
    store
  },
  template: '<App/>'
})
